import { io } from "socket.io-client";
import { SOCKET_URL } from "../helper/api_helper";

let _socket = null;

const stub = {
  on: () => {},
  off: () => {},
  emit: () => {},
  connect: () => {},
  disconnect: () => {},
  connected: false,
  id: null,
};

export function getSocket() {
  if (typeof window === "undefined") return stub;

  if (!_socket) {
    _socket = io(SOCKET_URL, {
      withCredentials: true,
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      autoConnect: false,
    });
  }

  return _socket;
}

export const socket = getSocket();

export function disconnectSocket() {
  if (_socket) {
    _socket.disconnect();
  }
}
